import { createFileRoute } from '@tanstack/react-router'
import { ModelProvidersPage } from '../../../modules/settings/model-providers-page'
import { SettingsShell } from '../../../modules/settings/settings-shell'

export const Route = createFileRoute('/_authed/settings/model-providers')({
  component: () => (
    <SettingsShell>
      <ModelProvidersPage />
    </SettingsShell>
  ),
})
